import React, { useEffect, useState } from "react";

import { linkPath } from "../../share/helper";
import { getCurrentUser, getImagelink_org_logo } from "../../share/getProfile";
import dayjs from "dayjs";
import QRWithIcon from "./qrcodeicon";
import { Col, Row } from "antd";
import { BiCheckCircle } from "react-icons/bi";

const Content = ({ dataViewer, dataViewerItem }) => {
  const [Org_ImagePath, SetOrgImagePath] = useState(
    "https://www.pngkit.com/png/full/981-9818240_your-logo-retulp-bus-stop.png"
  );
  const OrgProfile = getCurrentUser();

  useEffect(() => {
    const fetchLogo = async () => {
      const logoOrg = await getImagelink_org_logo("logo");
      if (logoOrg) {
        SetOrgImagePath(linkPath + logoOrg);
      } else {
        // Retry once if not found
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    };

    fetchLogo();
  }, []);

  const isChecked = (type, donorTypeString) => {
    try {
      const types = JSON.parse(donorTypeString);
      return types.includes(type);
    } catch (error) {
      return false;
    }
  };
  const dataArray = Array.isArray(dataViewerItem) ? dataViewerItem : [];
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "start", // Change to "center" if you want vertical centering
        minHeight: "100vh",
        backgroundColor: "#ccc", // page background
      }}
    >
      <div
        style={{
          width: "210mm",
          minHeight: "297mm",
          padding: "10mm",
          backgroundColor: "#fff",
          boxShadow: "0 0 5px rgba(253, 253, 253, 0.3)",
          fontFamily: '"Content", Arial, sans-serif',
          color: "#000",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            textAlign: "center",
            paddingBottom: "10px",
          }}
        >
          <div style={{}}>
            <div className="header-text">
              <span>ព្រះរាជាណាចក្រកម្ពុជា</span> <br />
              <span>ជាតិ សាសនា ព្រះមហាក្សត្រ</span>
              <br />
              <img
                src={linkPath + "tacteing_font.jpg"}
                alt="tacteing font"
                style={{ width: "10%" }}
              />
            </div>
          </div>
          <div
            style={{
              textAlign: "start",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between", // this is the correct property
                alignItems: "flex-start", // optional: align tops
                width: "100%",
              }}
            >
              <div>
                <img
                  src={Org_ImagePath}
                  alt="Organization Logo"
                  style={{
                    width: "80px",
                    height: "80px",
                    marginBottom: "5px",
                    marginLeft: 20,
                  }}
                />
                <span>
                  {OrgProfile.org_type <= 3 && (
                    <span className="header-text">
                      <br /> រដ្ឋបាលខេត្ត{OrgProfile.province_name} <br />
                    </span>
                  )}
                  {OrgProfile.org_type >= 4 && (
                    <span className="header-text">
                      <br /> មន្ទីរសុខាភិបាលនៃរដ្ឋបាលខេត្ត <br />
                    </span>
                  )}
                </span>

                {OrgProfile.org_type != 1 && (
                  <span className="header-text">
                    {/* {OrgProfile.org_cover_by} <br /> */}
                    មន្ទីរសុខាភិបាលនៃរដ្ឋបាលខេត្ត <br />
                  </span>
                )}
                <span className="header-text">{OrgProfile.org_name_kh}</span>
                <br />
              </div>
              <div>
                <QRWithIcon
                  value={dataViewer.ingerate_qrcode_id}
                  iconUrl={Org_ImagePath}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            textAlign: "center",
            backgroundColor: "#f1ededff",
            padding: "8px",
            marginBottom: "20px",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          ប័ណ្ណចុះឈ្មោះបរិច្ចាគឈាម
        </div>

        <span>
          • គោត្តនាម និងនាមខ្លួន: {dataViewer.full_name_kh}
          &nbsp;&nbsp;&nbsp;&nbsp; • លេខអត្តសញ្ញាណប័ណ្ណ:{" "}
          {dataViewer.national_id}
        </span>
        <br />
        <span>
          • ថ្ងៃខែឆ្នាំកំណើត: {dayjs(dataViewer.dob).format("DD-MM-YYYY")}
          &nbsp;&nbsp;&nbsp;&nbsp;អាយុ: {dataViewer.age} ឆ្នាំ &nbsp;&nbsp; ភេទ:{" "}
          {dataViewer.gender === "Male" ? "☑ ប្រុស ☐ ស្រី" : "☐ ប្រុស ☑ ស្រី"}
        </span>
        <br />
        <span>
          • ស្ថានភាពគ្រួសារ:{" "}
          {dataViewer.maritalStatus === "Single"
            ? "☑ នៅលីវ ☐ រៀបការ"
            : "☐ នៅលីវ ☑ រៀបការ"}
        </span>
        <br />
        <span>
          • មុខរបរ: {dataViewer.occupation}
          &nbsp;&nbsp;&nbsp;&nbsp; • កន្លែងធ្វើការ: {dataViewer.workplace}
        </span>
        <br />
        <span>
          • អាសយដ្ឋាន: ផ្ទះលេខ {dataViewer.houseNo}, ផ្លូវលេខ{" "}
          {dataViewer.street}, ភូមិ {dataViewer.village_kh}, សង្កាត់/ឃុំ{" "}
          {dataViewer.commune_kh}, ក្រុង/ស្រុក {dataViewer.city_kh}, ខេត្ត{" "}
          {dataViewer.province_kh}
        </span>
        <br />
        <span>
          • លេខទូរស័ព្ទ: {dataViewer.phone1} / អ៊ីម៉ែល: {dataViewer.email1}
        </span>
        <br />
        <span>
          (សូមមេត្តាអានដោយយកចិត្តទុកដាក់ និងបំពេញសំណួរសុខភាពនៅទំព័រក្រោយ)
        </span>

        <div>
          <div
            style={{
              textAlign: "center",
              backgroundColor: "#f1ededff",
              padding: "8px",
              marginTop: "10px",
              marginBottom: "20px",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            ការវិនិច្ឆ័យរបស់គ្រូពេទ្យ
          </div>
          {dataArray.length === 0 ? (
            <div style={{ marginBottom: "20px" }}>
              <div
                style={{
                  backgroundColor: "#f1ededff",
                  color: "#e10d0dff",
                  fontWeight: "bold",
                  width: "150px",
                  padding: "2px",
                  borderRadius: "8px",
                }}
              >
                <span>
                  <BiCheckCircle />
                  បរិច្ចាគឈាមលើកទី: ...
                </span>
              </div>
              <Row gutter={16}>
                <Col span={12}>
                  <span>• ថ្ងៃបរិច្ចាគឈាម : ......./...../......</span>
                </Col>
                <Col span={12}>
                  <span>• លេខកូដកន្លែង : ..........</span>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <span>• ទីកន្លែងបរិច្ចាគឈាម : .......</span>
                </Col>
                <Col span={12}>
                  <span>• លេខស្បោងឈាម: : ........</span>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <span>• ទម្ងន់ : ......... គក្រ</span>
                </Col>
                <Col span={12}>
                  <span>• អេម៉ូក្លូប៊ីន :......... ក្រាម/១០០មល</span>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <span>• សម្ពាធឈាម : ....../ ...... មីលីម៉ែត្របារ៉ត</span>
                </Col>
                <Col span={12}>
                  <span>• អេម៉ាតូគ្រីត : ........%</span>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <span>• ជីពចរ : ......... ក្នុង១នាទី</span>
                </Col>
                <Col span={12}>
                  <span>• ក្រុមឈាម ABO : ....... រ៉េស៊ីស(RhD): ..........</span>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6}>
                  <span>• ប្រភេទអ្នកបរិច្ចាគឈាម:</span>
                </Col>
                <Col span={18}>
                  <span>
                    □ SD &nbsp;&nbsp; □ cSD &nbsp;&nbsp; □ ED &nbsp;&nbsp; □ RD
                  </span>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6}>
                  <span>• ប្រភេទស្បោងឈាម:</span>
                </Col>
                <Col span={18}>
                  <span>
                    □ ស្បោងទោល &nbsp;&nbsp; □ ស្បោងភ្លោះ &nbsp;&nbsp; □
                    ស្បោងភ្លោះ៣
                  </span>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6}>
                  <span> • ការវិនិច្ឆ័យ: </span>
                </Col>
                <Col span={18}>
                  <span>
                    □ អនុញ្ញាតផ្ដល់ឈាម - ចំណុះឈាមត្រូវបូម : .. ...... មីលីលីត្រ
                    <br />□ ហាមផ្ដល់ឈាមមួយរយៈរហូតដល់ថ្ងៃទី {"..../..../...."}
                    <br />□ ហាមផ្ដល់ឈាមជារៀងរហូត
                  </span>
                  <br />
                  <span>
                    មូលហេតុ: □ អេម៉ូក្លូប៊ីន ឬ អេម៉ាតូគ្រីត / □ សម្ពាធឈាម / □
                    ទម្ងន់ / □ ប្រវត្តិជំងឺ <br />□ ស្ថានភាពប្រឈមមុខ / □ អាយុ /
                    □ មុនកាលកំណត់ / □ ផ្សេងទៀត <br />
                  </span>
                  <span>
                    • បញ្ហាផ្សេងៗ:
                    .........................................................................
                  </span>
                </Col>
              </Row>
            </div>
          ) : (
            dataArray.map((item, index) => (
              <div
                key={item.id || index}
                className="print-content"
                style={{ marginBottom: "20px" }}
              >
                <div
                  style={{
                    backgroundColor: "#f1ededff",
                    color: "#e10d0dff",
                    fontWeight: "bold",
                    width: "150px",
                    padding: "2px",
                    borderRadius: "8px",
                  }}
                >
                  <span>
                    <BiCheckCircle /> បរិច្ចាគឈាមលើកទី: {index + 1}
                  </span>
                </div>
                <Row gutter={16}>
                  <Col span={12}>
                    <span>
                      • ថ្ងៃបរិច្ចាគឈាម :
                      {dayjs(item.donation_date).format("DD/MM/YYYY")}
                    </span>
                  </Col>
                  <Col span={12}>
                    <span>• លេខកូដកន្លែង : ...{item.donator_code}...</span>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <span>
                      • ទីកន្លែងបរិច្ចាគឈាម : ...{item.donation_place}...
                    </span>
                  </Col>
                  <Col span={12}>
                    <span>• លេខស្បោងឈាម: : ...{item.place_code}...</span>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <span>• ទម្ងន់ : ...{item.weight_kg}.... គក្រ</span>
                  </Col>
                  <Col span={12}>
                    <span>
                      • អេម៉ូក្លូប៊ីន :...{item.hemoglobin}... ក្រាម/១០០មល
                    </span>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <span>
                      • សម្ពាធឈាម : {item.blood_pressure_systolic}/
                      {item.blood_pressure_diastolic} មីលីម៉ែត្របារ៉ត
                    </span>
                  </Col>
                  <Col span={12}>
                    <span>• អេម៉ាតូគ្រីត : ....{item.hematocrit}...%</span>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <span>• ជីពចរ : ...{item.pulse_rate}... ក្នុង១នាទី</span>
                  </Col>
                  <Col span={12}>
                    <span>
                      • ក្រុមឈាម ABO : {item.blood_group_abo} រ៉េស៊ីស(RhD):{" "}
                      {item.rhesus}
                    </span>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={6}>
                    <span>• ប្រភេទអ្នកបរិច្ចាគឈាម:</span>
                  </Col>
                  <Col span={18}>
                    <span>
                      {isChecked("SD", item.donor_type) ? "☑" : "□"} SD
                      &nbsp;&nbsp;
                      {isChecked("cSD", item.donor_type) ? "☑" : "□"} cSD
                      &nbsp;&nbsp;
                      {isChecked("ED", item.donor_type) ? "☑" : "□"} ED
                      &nbsp;&nbsp;
                      {isChecked("RD", item.donor_type) ? "☑" : "□"} RD
                    </span>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={6}>
                    <span>• ប្រភេទស្បោងឈាម:</span>
                  </Col>
                  <Col span={18}>
                    <span>
                      {item.blood_bag_type === "single" ? "☑" : "□"}
                      ស្បោងទោល &nbsp;&nbsp;{" "}
                      {item.blood_bag_type === "double" ? "☑" : "□"}
                      ស្បោងភ្លោះ &nbsp;&nbsp;{" "}
                      {item.blood_bag_type === "triple" ? "☑" : "□"}
                      ស្បោងភ្លោះ៣
                    </span>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={6}>
                    <span> • ការវិនិច្ឆ័យ: </span>
                  </Col>
                  <Col span={18}>
                    <span>
                      {item.diagnosis_result === "allowed" ? "☑" : "□"}
                      អនុញ្ញាតផ្ដល់ឈាម - ចំណុះឈាមត្រូវបូម : ..
                      <b>{item.blood_amount_ml}</b>.. មីលីលីត្រ
                      <br />{" "}
                      {item.diagnosis_result === "temporary_ban" ? "☑" : "□"}
                      ហាមផ្ដល់ឈាមមួយរយៈរហូតដល់ថ្ងៃទី{" "}
                      {item.prohibited_until_date || "..../..../...."}
                      <br />
                      {item.diagnosis_result === "permanent_ban" ? "☑" : "□"}
                      ហាមផ្ដល់ឈាមជារៀងរហូត
                    </span>
                    <br />
                    <span>
                      <b> មូលហេតុ៖ </b>
                      {isChecked("ck_hemoglobin", item.rejection_reason)
                        ? "☑"
                        : "□"}{" "}
                      អេម៉ូក្លូប៊ីន ឬ អេម៉ាតូគ្រីត /
                      {isChecked("ck_pressure", item.rejection_reason)
                        ? "☑"
                        : "□"}{" "}
                      សម្ពាធឈាម /
                      {isChecked("ck_weight", item.rejection_reason)
                        ? "☑"
                        : "□"}{" "}
                      ទម្ងន់ /
                      {isChecked("ck_history", item.rejection_reason)
                        ? "☑"
                        : "□"}{" "}
                      ប្រវត្តិជំងឺ
                      {isChecked("ck_status", item.rejection_reason)
                        ? "☑"
                        : "□"}{" "}
                      ស្ថានភាពប្រឈមមុខ /
                      {isChecked("ck_age", item.rejection_reason) ? "☑" : "□"}{" "}
                      អាយុ /
                      {isChecked("ck_early", item.rejection_reason) ? "☑" : "□"}{" "}
                      មុនកាលកំណត់ /
                      {isChecked("ck_other", item.rejection_reason) ? "☑" : "□"}{" "}
                      ផ្សេងទៀត
                    </span>
                    <span>
                      <br />• បញ្ហាផ្សេងៗ:
                      .........................................................................
                    </span>
                  </Col>
                </Row>
              </div>
            ))
          )}
        </div>
      </div>

      {/* list data  */}
    </div>
  );
};

export default Content;
